import PropTypes from 'prop-types'
import { Dropdown } from 'primereact/dropdown'
import { MultiSelect } from 'primereact/multiselect'

import style from '@aytm/app/stats/page/question-views/hm/components/answers-stats/styles/AnswersStats.module.scss'
import { getStopWordLevelPlaceholder } from '@aytm/app/stats/page/question-views/hm/components/answers-stats/lib/utils'

export const AnswersStats = ({ form, isLoading, onChangeModel }) => {
  if (!form.answersStats.isEnabled) return null

  const handleChange = e => onChangeModel({ [e.target.name]: e.target.value })

  return (
    <div className={style.answersStats}>
      <Dropdown
        className="p-dropdown-rounded"
        aria-label="Statistics"
        ariaLabel="Statistics"
        name="statType"
        value={form.answersStats.statType.value}
        options={form.answersStats.statType.options}
        optionValue="value"
        optionLabel="text"
        fixedDropdownDir="bottom"
        disabled={isLoading}
        onChange={handleChange}
      />

      {form.answersStats.blockType.isVisible && (
        <Dropdown
          // the cluster kinds are a short fixed list, so it draws whole (the library caps it at 200px)
          className="p-dropdown-rounded p-dropdown-no-scroll"
          aria-label="Clusters shown"
          ariaLabel="Clusters shown"
          name="blockType"
          value={form.answersStats.blockType.value}
          options={form.answersStats.blockType.options}
          optionValue="value"
          optionLabel="text"
          fixedDropdownDir="bottom"
          disabled={isLoading}
          onChange={handleChange}
        />
      )}

      {form.answersStats.stopWordLevel.isVisible && (
        <MultiSelect
          name="stopWordLevel"
          // six fixed levels, drawn whole like the cluster kinds above
          className="p-multiselect-rounded p-multiselect-no-scroll"
          placeholder={getStopWordLevelPlaceholder(
            form.answersStats.stopWordLevel.value,
            form.answersStats.stopWordLevel.options
          )}
          fixedPlaceholder={true}
          value={form.answersStats.stopWordLevel.value}
          options={form.answersStats.stopWordLevel.options}
          optionValue="value"
          optionLabel="text"
          panelHeaderTemplate={<div />}
          showSelectAll={false}
          removeIcon={null}
          disabled={isLoading}
          onChange={handleChange}
        />
      )}
    </div>
  )
}

AnswersStats.propTypes = {
  form: PropTypes.shape({
    answersStats: PropTypes.shape({
      isEnabled: PropTypes.bool,
      statType: PropTypes.shape({ value: PropTypes.string, options: PropTypes.array }),
      blockType: PropTypes.shape({ value: PropTypes.string, options: PropTypes.array, isVisible: PropTypes.bool }),
      stopWordLevel: PropTypes.shape({ value: PropTypes.array, options: PropTypes.array, isVisible: PropTypes.bool })
    })
  }).isRequired,
  isLoading: PropTypes.bool,
  onChangeModel: PropTypes.func
}
